(function () {
  'use strict';
  function init() {
    var bar = document.getElementById('ll-sticky-atc');
    if (!bar) return;
    var scope = document.querySelector('.product-main') || document;
    var form = scope.querySelector('form[action*="/cart/add"]');
    var mainBtn = form ? form.querySelector('[name="add"]') : null;
    if (!form || !mainBtn) return;

    var data = {};
    var dataEl = document.getElementById('ll-satc-data');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent).variants || {}; } catch (err) { data = {}; }
    }

    var btn = bar.querySelector('.ll-satc-btn');
    var btnText = bar.querySelector('.ll-satc-text');
    var priceEl = bar.querySelector('.ll-satc-current');
    var compareEl = bar.querySelector('.ll-satc-compare');

    btn.addEventListener('click', function () {
      mainBtn.click();
    });

    var mainCheck = mainBtn.querySelector('.checkmark');
    if (mainCheck && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        btn.classList.toggle('ll-satc-added', mainCheck.classList.contains('checkmark-active'));
      });
      mo.observe(mainCheck, { attributes: true, attributeFilter: ['class'] });
    }

    var idInput = form.querySelector('[name="id"]');
    function sync() {
      if (!idInput) return;
      var v = data[String(idInput.value)];
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.style.display = v.onSale ? '' : 'none';
        if (v.onSale) compareEl.textContent = v.compare;
      }
      btn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
    }
    form.addEventListener('change', function () { window.setTimeout(sync, 50); });
    sync();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var passed = entry.isIntersecting === false && entry.boundingClientRect.top<0;
        bar.classList.toggle('ll-satc--visible', passed);
      }, { threshold: 0 });
      io.observe(mainBtn);
    } else {
      bar.classList.add('ll-satc--visible');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
